export const ValidateFileSize = (file) => {
  const company = localStorage.getItem("company")
    ? JSON.parse(localStorage.getItem("company"))
    : null;
  const maxSize = company.max_file_size || 5 * 1024 * 1024;

  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `The file (${
        file.name
      }) size exceeds the maximum file upload limit (${
        (maxSize / 1024) / 1024
      }MB)`,
    };
  }
  return { isValid: true };
};
